export default function Cards() {
  return (
    <section className="cards">
      <div>
        <h5>ყველასთვის ხელმისაწვდომი</h5>
        <p>
          თბილისი ბუთკემპის მიზანი ადამიანების უნარების სწრაფად განვითარების
          ხელშეწყობაა
        </p>
      </div>
      <div>
        <h5>სუპერ ინტენსიური</h5>
        <p>
          ბუთკემპში სწავლობ კვირაში 5 დღე, თითოეულ ჯგუფში მაქსიმუმ 8 სტუდენტია,
          რაც ნიშნავს რომ ტუტორის ყურადღება არავის მოაკლდება
        </p>
      </div>
      <div>
        <h5>ნახტომი კარიერაში</h5>
        <p>
          კურსის დასრულების შემდეგ, მზად იქნები დასაქმდე სტაჟიორად ან ჯუნიორ
          დეველოპერად
        </p>
      </div>
    </section>
  );
}
